var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { SUCCESS_SUFFIX, ERROR_SUFFIX, ABORT_SUFFIX } from './constants';
export var getActionWithSuffix = function getActionWithSuffix(suffix) {
  return function (actionType) {
    return actionType + suffix;
  };
};
export var success = getActionWithSuffix(SUCCESS_SUFFIX);
export var error = getActionWithSuffix(ERROR_SUFFIX);
export var abort = getActionWithSuffix(ABORT_SUFFIX);

var isFSA = function isFSA(action) {
  return !!action.payload;
};

export var successAction = function successAction(action, data) {
  return _extends({}, isFSA(action) ? {
    payload: {
      data: data
    }
  } : {
    data: data
  }, {
    meta: _extends({}, action.meta, {
      requestAction: action
    })
  });
};
export var errorAction = function errorAction(action, errorData) {
  return _extends({}, isFSA(action) ? {
    payload: errorData,
    error: true
  } : {
    error: errorData
  }, {
    meta: _extends({}, action.meta, {
      requestAction: action
    })
  });
};
export var abortAction = function abortAction(action) {
  return {
    meta: _extends({}, action.meta, {
      requestAction: action
    })
  };
};